import { cn } from '@/lib/utils'

interface Props {
  isActive?: boolean
  onClick?: () => void
  isDisabled?: boolean
  title: string
}

export const ProductInfoSizeItem = ({
  isActive,
  onClick,
  isDisabled,
  title,
}: Props) => {
  return (
    <li>
      <button
        onClick={onClick}
        className={cn(
          'relative h-9 min-w-13 rounded-xl bg-neutral-100 p-2 font-sans text-base leading-5 text-neutral-600 hover:bg-neutral-900 hover:text-light lg:h-11 lg:min-w-17.5 lg:bg-neutral-300',
          isDisabled &&
            'pointer-events-none cursor-not-allowed !bg-neutral-100/50 !text-neutral-300 before:absolute before:left-0 before:top-1/2 before:w-full before:rotate-[30deg] before:border-t before:border-dashed before:border-neutral-300 after:absolute after:left-0 after:top-1/2 after:w-full after:rotate-[145deg] after:border-t after:border-dashed after:border-neutral-300 lg:bg-neutral-100/50',
          isActive && 'bg-neutral-900 text-light lg:bg-neutral-900',
          // Size đang chọn nhưng hết hàng ở màu hiện tại: vẫn đánh dấu là đang chọn
          isActive && isDisabled && 'ring-1 ring-neutral-900'
        )}
      >
        {title}
      </button>
    </li>
  )
}
